import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { CREATE_TALENT_SCORE } from "../graphql/mutations";
import { ENG1ROLES, ENG2ROLES, ENG3ROLES, ENG4ROLES, ENG5ROLES, ENG6ROLES, ENG7ROLES, ENG8ROLES, DO1ROLES, DO2ROLES, DO3ROLES, DP1ROLES, DP2ROLES, DP3ROLES, DAF1ROLES, DAF2ROLES, DAF3ROLES, BED1ROLES, BED2ROLES } from "../graphql/queries";
import CustomSelect from "./CustomSelect";
import { Link } from "react-router-dom";

// eslint-disable-next-line no-unused-vars
const axios = require("axios");

function TalentScore(props) {
  const confirmationCode = props.match.params.code;
  const startupId = props.match.params.startupId;

  const [valid, setValid] = useState(false);
  const [done, setDone] = useState(false);

  // ????
  useEffect(() => {
    const confirmationUrl =
      process.env.REACT_APP_MAIL_CONFIRMATION_PROFILE_CONFIRMATION_URL ||
      "https://f1j07exi8h.execute-api.eu-central-1.amazonaws.com/dev/profile-confirmation";
    fetch(`${confirmationUrl}?code=${confirmationCode}&startupid=${startupId}`)
      .then((response) => {
        setValid(response.status === 200);
        setDone(true);
      })
      .catch((_) => setDone(true));
  }, [confirmationCode, startupId]);

  // Fetch ENG1ROLES
  const [eng1ranges, setEng1ranges] = useState();
  const eng1rangesQuery = useQuery(ENG1ROLES);
  useEffect(() => {
    if (eng1rangesQuery?.data) {
      const dataReceived = eng1rangesQuery?.data.eng1Ranges?.data.map(
        (eng1ranges) => ({
          value: eng1ranges.id,
          label: eng1ranges.attributes.value,
        })
      );

      setEng1ranges(dataReceived);
    }
  }, [eng1rangesQuery?.data, eng1rangesQuery.error]);

  // Fetch ENG2ROLES
  const [eng2ranges, setEng2ranges] = useState();
  const eng2rangesQuery = useQuery(ENG2ROLES);
  useEffect(() => {
    if (eng2rangesQuery?.data) {
      const dataReceived = eng2rangesQuery?.data.eng2Ranges?.data.map(
        (eng2ranges) => ({
          value: eng2ranges.id,
          label: eng2ranges.attributes.value,
        })
      );

      setEng2ranges(dataReceived);
    }
  }, [eng2rangesQuery?.data, eng2rangesQuery.error]);

  // Fetch ENG3ROLES
  const [eng3ranges, setEng3ranges] = useState();
  const eng3rangesQuery = useQuery(ENG3ROLES);
  useEffect(() => {
    if (eng3rangesQuery?.data) {
      const dataReceived = eng3rangesQuery?.data.eng3Ranges?.data.map(
        (eng3ranges) => ({
          value: eng3ranges.id,
          label: eng3ranges.attributes.value,
        })
      );

      setEng3ranges(dataReceived);
    }
  }, [eng3rangesQuery?.data, eng3rangesQuery.error]);

  // Fetch ENG4ROLES
  const [eng4ranges, setEng4ranges] = useState();
  const eng4rangesQuery = useQuery(ENG4ROLES);
  useEffect(() => {
    if (eng4rangesQuery?.data) {
      const dataReceived = eng4rangesQuery?.data.eng4Ranges?.data.map(
        (eng4ranges) => ({
          value: eng4ranges.id,
          label: eng4ranges.attributes.value,
        })
      );

      setEng4ranges(dataReceived);
    }
  }, [eng4rangesQuery?.data, eng4rangesQuery.error]);

  // Fetch ENG5ROLES
  const [eng5ranges, setEng5ranges] = useState();
  const eng5rangesQuery = useQuery(ENG5ROLES);
  useEffect(() => {
    if (eng5rangesQuery?.data) {
      const dataReceived = eng5rangesQuery?.data.eng5Ranges?.data.map(
        (eng5ranges) => ({
          value: eng5ranges.id,
          label: eng5ranges.attributes.value,
        })
      );

      setEng5ranges(dataReceived);
    }
  }, [eng5rangesQuery?.data, eng5rangesQuery.error]);

  // Fetch ENG6ROLES
  const [eng6ranges, setEng6ranges] = useState();
  const eng6rangesQuery = useQuery(ENG6ROLES);
  useEffect(() => {
    if (eng6rangesQuery?.data) {
      const dataReceived = eng6rangesQuery?.data.eng6Ranges?.data.map(
        (eng6ranges) => ({
          value: eng6ranges.id,
          label: eng6ranges.attributes.value,
        })
      );

      setEng6ranges(dataReceived);
    }
  }, [eng6rangesQuery?.data, eng6rangesQuery.error]);

  // Fetch ENG7ROLES
  const [eng7ranges, setEng7ranges] = useState();
  const eng7rangesQuery = useQuery(ENG7ROLES);
  useEffect(() => {
    if (eng7rangesQuery?.data) {
      const dataReceived = eng7rangesQuery?.data.eng7Ranges?.data.map(
        (eng7ranges) => ({
          value: eng7ranges.id,
          label: eng7ranges.attributes.value,
        })
      );

      setEng7ranges(dataReceived);
    }
  }, [eng7rangesQuery?.data, eng7rangesQuery.error]);

  // Fetch ENG8ROLES
  const [eng8ranges, setEng8ranges] = useState();
  const eng8rangesQuery = useQuery(ENG8ROLES);
  useEffect(() => {
    if (eng8rangesQuery?.data) {
      const dataReceived = eng8rangesQuery?.data.eng8Ranges?.data.map(
        (eng8ranges) => ({
          value: eng8ranges.id,
          label: eng8ranges.attributes.value,
        })
      );

      setEng8ranges(dataReceived);
    }
  }, [eng8rangesQuery?.data, eng8rangesQuery.error]);

  // Fetch DO1ROLES
  const [do1ranges, setDo1ranges] = useState();
  const do1rangesQuery = useQuery(DO1ROLES);
  useEffect(() => {
    if (do1rangesQuery?.data) {
      const dataReceived = do1rangesQuery?.data.dO1Ranges?.data.map(
        (do1ranges) => ({
          value: do1ranges.id,
          label: do1ranges.attributes.value,
        })
      );

      setDo1ranges(dataReceived);
    }
  }, [do1rangesQuery?.data, do1rangesQuery.error]);

  // Fetch DO2ROLES
  const [do2ranges, setDo2ranges] = useState();
  const do2rangesQuery = useQuery(DO2ROLES);
  useEffect(() => {
    if (do2rangesQuery?.data) {
      const dataReceived = do2rangesQuery?.data.dO2Ranges?.data.map(
        (do2ranges) => ({
          value: do2ranges.id,
          label: do2ranges.attributes.value,
        })
      );

      setDo2ranges(dataReceived);
    }
  }, [do2rangesQuery?.data, do2rangesQuery.error]);

  // Fetch DO3ROLES
  const [do3ranges, setDo3ranges] = useState();
  const do3rangesQuery = useQuery(DO3ROLES);
  useEffect(() => {
    if (do3rangesQuery?.data) {
      const dataReceived = do3rangesQuery?.data.dO3Ranges?.data.map(
        (do3ranges) => ({
          value: do3ranges.id,
          label: do3ranges.attributes.value,
        })
      );

      setDo3ranges(dataReceived);
    }
  }, [do3rangesQuery?.data, do3rangesQuery.error]);

  // Fetch DP1ROLES
  const [dp1ranges, setDp1ranges] = useState();
  const dp1rangesQuery = useQuery(DP1ROLES);
  useEffect(() => {
    if (dp1rangesQuery?.data) {
      const dataReceived = dp1rangesQuery?.data.dP1Ranges?.data.map(
        (dp1ranges) => ({
          value: dp1ranges.id,
          label: dp1ranges.attributes.value,
        })
      );

      setDp1ranges(dataReceived);
    }
  }, [dp1rangesQuery?.data, dp1rangesQuery.error]);

  // Fetch DP2ROLES
  const [dp2ranges, setDp2ranges] = useState();
  const dp2rangesQuery = useQuery(DP2ROLES);
  useEffect(() => {
    if (dp2rangesQuery?.data) {
      const dataReceived = dp2rangesQuery?.data.dP2Ranges?.data.map(
        (dp2ranges) => ({
          value: dp2ranges.id,
          label: dp2ranges.attributes.value,
        })
      );

      setDp2ranges(dataReceived);
    }
  }, [dp2rangesQuery?.data, dp2rangesQuery.error]);

  // Fetch DP3ROLES
  const [dp3ranges, setDp3ranges] = useState();
  const dp3rangesQuery = useQuery(DP3ROLES);
  useEffect(() => {
    if (dp3rangesQuery?.data) {
      const dataReceived = dp3rangesQuery?.data.dP3Ranges?.data.map(
        (dp3ranges) => ({
          value: dp3ranges.id,
          label: dp3ranges.attributes.value,
        })
      );

      setDp3ranges(dataReceived);
    }
  }, [dp3rangesQuery?.data, dp3rangesQuery.error]);

  // Fetch DAF1ROLES
  const [daf1ranges, setDaf1ranges] = useState();
  const daf1rangesQuery = useQuery(DAF1ROLES);
  useEffect(() => {
    if (daf1rangesQuery?.data) {
      const dataReceived = daf1rangesQuery?.data.daf1Ranges?.data.map(
        (daf1ranges) => ({
          value: daf1ranges.id,
          label: daf1ranges.attributes.value,
        })
      );

      setDaf1ranges(dataReceived);
    }
  }, [daf1rangesQuery?.data, daf1rangesQuery.error]);

  // Fetch DAF2ROLES
  const [daf2ranges, setDaf2ranges] = useState();
  const daf2rangesQuery = useQuery(DAF2ROLES);
  useEffect(() => {
    if (daf2rangesQuery?.data) {
      const dataReceived = daf2rangesQuery?.data.daf2Ranges?.data.map(
        (daf2ranges) => ({
          value: daf2ranges.id,
          label: daf2ranges.attributes.value,
        })
      );

      setDaf2ranges(dataReceived);
    }
  }, [daf2rangesQuery?.data, daf2rangesQuery.error]);

  // Fetch DAF3ROLES
  const [daf3ranges, setDaf3ranges] = useState();
  const daf3rangesQuery = useQuery(DAF3ROLES);
  useEffect(() => {
    if (daf3rangesQuery?.data) {
      const dataReceived = daf3rangesQuery?.data.daf3Ranges?.data.map(
        (daf3ranges) => ({
          value: daf3ranges.id,
          label: daf3ranges.attributes.value,
        })
      );

      setDaf3ranges(dataReceived);
    }
  }, [daf3rangesQuery?.data, daf3rangesQuery.error]);

  // Fetch BED1ROLES
  const [bed1ranges, setBed1ranges] = useState();
  const bed1rangesQuery = useQuery(BED1ROLES);
  useEffect(() => {
    if (bed1rangesQuery?.data) {
      const dataReceived = bed1rangesQuery?.data.bed1Ranges?.data.map(
        (bed1ranges) => ({
          value: bed1ranges.id,
          label: bed1ranges.attributes.value,
        })
      );

      setBed1ranges(dataReceived);
    }
  }, [bed1rangesQuery?.data, bed1rangesQuery.error]);

  // Fetch BED2ROLES
  const [bed2ranges, setBed2ranges] = useState();
  const bed2rangesQuery = useQuery(BED2ROLES);
  useEffect(() => {
    if (bed2rangesQuery?.data) {
      const dataReceived = bed2rangesQuery?.data.bed2Ranges?.data.map(
        (bed2ranges) => ({
          value: bed2ranges.id,
          label: bed2ranges.attributes.value,
        })
      );

      setBed2ranges(dataReceived);
    }
  }, [bed2rangesQuery?.data, bed2rangesQuery.error]);

  /* eng1range */
  const [eng1range, setEng1range] = useState("");
  const [eng1rangeError, setEng1rangeError] = useState("");
  function handleChangeeng1range(selectedOption) {
    setEng1range(selectedOption.value);
    setEng1rangeError("");
  }

  /* eng2range */
  const [eng2range, setEng2range] = useState("");
  const [eng2rangeError, setEng2rangeError] = useState("");
  function handleChangeeng2range(selectedOption) {
    setEng2range(selectedOption.value);
    setEng2rangeError("");
  }

  /* eng3range */
  const [eng3range, setEng3range] = useState("");
  const [eng3rangeError, setEng3rangeError] = useState("");
  function handleChangeeng3range(selectedOption) {
    setEng3range(selectedOption.value);
    setEng3rangeError("");
  }

  /* eng4range */
  const [eng4range, setEng4range] = useState("");
  const [eng4rangeError, setEng4rangeError] = useState("");
  function handleChangeeng4range(selectedOption) {
    setEng4range(selectedOption.value);
    setEng4rangeError("");
  }

  /* eng5range */
  const [eng5range, setEng5range] = useState("");
  const [eng5rangeError, setEng5rangeError] = useState("");
  function handleChangeeng5range(selectedOption) {
    setEng5range(selectedOption.value);
    setEng5rangeError("");
  }

  /* eng6range */
  const [eng6range, setEng6range] = useState("");
  const [eng6rangeError, setEng6rangeError] = useState("");
  function handleChangeeng6range(selectedOption) {
    setEng6range(selectedOption.value);
    setEng6rangeError("");
  }

  /* eng7range */
  const [eng7range, setEng7range] = useState("");
  const [eng7rangeError, setEng7rangeError] = useState("");
  function handleChangeeng7range(selectedOption) {
    setEng7range(selectedOption.value);
    setEng7rangeError("");
  }

  /* eng8range */
  const [eng8range, setEng8range] = useState("");
  const [eng8rangeError, setEng8rangeError] = useState("");
  function handleChangeeng8range(selectedOption) {
    setEng8range(selectedOption.value);
    setEng8rangeError("");
  }

  /* do1range */
  const [do1range, setDo1range] = useState("");
  const [do1rangeError, setDo1rangeError] = useState("");
  function handleChangedo1range(selectedOption) {
    setDo1range(selectedOption.value);
    setDo1rangeError("");
  }

  /* do2range */
  const [do2range, setDo2range] = useState("");
  const [do2rangeError, setDo2rangeError] = useState("");
  function handleChangedo2range(selectedOption) {
    setDo2range(selectedOption.value);
    setDo2rangeError("");
  }

  /* do3range */
  const [do3range, setDo3range] = useState("");
  const [do3rangeError, setDo3rangeError] = useState("");
  function handleChangedo3range(selectedOption) {
    setDo3range(selectedOption.value);
    setDo3rangeError("");
  }

  /* dp1range */
  const [dp1range, setDp1range] = useState("");
  const [dp1rangeError, setDp1rangeError] = useState("");
  function handleChangedp1range(selectedOption) {
    setDp1range(selectedOption.value);
    setDp1rangeError("");
  }

  /* dp2range */
  const [dp2range, setDp2range] = useState("");
  const [dp2rangeError, setDp2rangeError] = useState("");
  function handleChangedp2range(selectedOption) {
    setDp2range(selectedOption.value);
    setDp2rangeError("");
  }

  /* dp3range */
  const [dp3range, setDp3range] = useState("");
  const [dp3rangeError, setDp3rangeError] = useState("");
  function handleChangedp3range(selectedOption) {
    setDp3range(selectedOption.value);
    setDp3rangeError("");
  }

  /* daf1range */
  const [daf1range, setDaf1range] = useState("");
  const [daf1rangeError, setDaf1rangeError] = useState("");
  function handleChangedaf1range(selectedOption) {
    setDaf1range(selectedOption.value);
    setDaf1rangeError("");
  }

  /* daf2range */
  const [daf2range, setDaf2range] = useState("");
  const [daf2rangeError, setDaf2rangeError] = useState("");
  function handleChangedaf2range(selectedOption) {
    setDaf2range(selectedOption.value);
    setDaf2rangeError("");
  }

  /* daf3range */
  const [daf3range, setDaf3range] = useState("");
  const [daf3rangeError, setDaf3rangeError] = useState("");
  function handleChangedaf3range(selectedOption) {
    setDaf3range(selectedOption.value);
    setDaf3rangeError("");
  }

  /*bed1range*/
  const [bed1range, setBed1range] = useState("");
  const [bed1rangeError, setBed1rangeError] = useState("");
  function handleChangeBed1range(selectedOption) {
    setBed1range(selectedOption.value);
    setBed1rangeError("");
  }

  /*bed2range*/
  const [bed2range, setBed2range] = useState("");
  const [bed2rangeError, setBed2rangeError] = useState("");
  function handleChangeBed2range(selectedOption) {
    setBed2range(selectedOption.value);
    setBed2rangeError("");
  }

  const [success, setSuccess] = useState();
  const [createTalentScore, { loadingTalentScore }] = useMutation(
    CREATE_TALENT_SCORE,
    {
      onCompleted: (providerData) => {
        setSuccess(true);
      },
    }
  );
  const handleSubmit = (e) => {
    e.preventDefault();
    if (eng1range === "") {
      setEng1rangeError("Please select a valid entry.");
      document.getElementById("select-Eng1").scrollIntoView();

    } else if (eng2range === "") {
      setEng2rangeError("Please select a valid entry.");
      document.getElementById("select-Eng2").scrollIntoView();

    } else if (eng3range === "") {
      setEng3rangeError("Please select a valid entry.");
      document.getElementById("select-Eng3").scrollIntoView();

    } else if (eng4range === "") {
      setEng4rangeError("Please select a valid entry.");
      document.getElementById("select-Eng4").scrollIntoView();

    } else if (eng5range === "") {
      setEng5rangeError("Please select a valid entry.");
      document.getElementById("select-Eng5").scrollIntoView();

    } else if (eng6range === "") {
      setEng6rangeError("Please select a valid entry.");
      document.getElementById("select-Eng6").scrollIntoView();

    } else if (eng7range === "") {
      setEng7rangeError("Please select a valid entry.");
      document.getElementById("select-Eng7").scrollIntoView();

    } else if (eng8range === "") {
      setEng8rangeError("Please select a valid entry.");
      document.getElementById("select-Eng8").scrollIntoView();

    } else if (do1range === "") {
      setDo1rangeError("Please select a valid entry.");
      document.getElementById("select-Do1").scrollIntoView();

    } else if (do2range === "") {
      setDo2rangeError("Please select a valid entry.");
      document.getElementById("select-Do2").scrollIntoView();

    } else if (do3range === "") {
      setDo3rangeError("Please select a valid entry.");
      document.getElementById("select-Do3").scrollIntoView();

    } else if (dp1range === "") {
      setDp1rangeError("Please select a valid entry.");
      document.getElementById("select-Dp1").scrollIntoView();

    } else if (dp2range === "") {
      setDp2rangeError("Please select a valid entry.");
      document.getElementById("select-Dp2").scrollIntoView();

    } else if (dp3range === "") {
      setDp3rangeError("Please select a valid entry.");
      document.getElementById("select-Dp3").scrollIntoView();

    } else if (daf1range === "") {
      setDaf1range("Please select a valid entry.");
      document.getElementById("select-Daf1").scrollIntoView();

    } else if (daf2range === "") {
      setDaf2range("Please select a valid entry.");
      document.getElementById("select-Daf2").scrollIntoView();

    } else if (daf3range === "") {
      setDaf3range("Please select a valid entry.");
      document.getElementById("select-Daf3").scrollIntoView();

    } else if (bed1range === "") {
      setBed1rangeError("Please select a valid entry.");
      document.getElementById("select-Bed1").scrollIntoView();

    } else if (bed2range === "") {
      setBed2rangeError("Please select a valid entry.");

    } else {
      createTalentScore({
        variables: {
          ENG_1: eng1range,
          ENG_2: eng2range,
          ENG_3: eng3range,
          ENG_4: eng4range,
          ENG_5: eng5range,
          ENG_6: eng6range,
          ENG_7: eng7range,
          ENG_8: eng8range,
          D_O1: do1range,
          D_O2: do2range,
          D_O3: do3range,
          D_P1: dp1range,
          D_P2: dp2range,
          D_P3: dp3range,
          DAF_1: daf1range,
          DAF_2: daf2range,
          DAF_3: daf3range,
          BED1: bed1range,
          BED2: bed2range,
          startupid: startupId
        },
      });
    }
  };
  return (
    <div className="absolute left-0 right-0 flex flex-col items-center overflow-y-auto bottom-14 top-20">
      {!success && valid && done && (
        <>
          <h1 className="m-2 mt-10">Talent Score</h1>

          <div className="flex flex-wrap">
            <div className="w-full">
            <p><strong>All data is collected anonymously and cannot be tracked back to you.</strong></p>  
              <form
                onSubmit={handleSubmit}
                className="w-full max-w-xl p-4 m-auto"
              >
                        <div className="flex-col w-full center">
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            For me, the startup will also remain an attractive
                            employer in the future.
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Eng1"
                            onChange={handleChangeeng1range}
                            options={eng1ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {eng1rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {eng1rangeError}
                            </p>
                          )}
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            I feel emotionally attached to the startup.
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Eng2"
                            onChange={handleChangeeng2range}
                            options={eng2ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {eng2rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {eng2rangeError}
                            </p>
                          )}
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            I would recommend the startup as an employer to
                            friends and acquaintances.
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Eng3"
                            onChange={handleChangeeng3range}
                            options={eng3ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {eng3rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {eng3rangeError}
                            </p>
                          )}
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            I am proud to tell others that I work for the
                            startup.
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Eng4"
                            onChange={handleChangeeng4range}
                            options={eng4ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {eng4rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {eng4rangeError}
                            </p>
                          )}
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            I am prepared to do more than is expected of me to
                            ensure the success of the startup if necessary.
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Eng5"
                            onChange={handleChangeeng5range}
                            options={eng5ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {eng5rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {eng5rangeError}
                            </p>
                          )}
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            The staff here is prepared to put in extra effort to
                            meet future challenges if required.
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Eng6"
                            onChange={handleChangeeng6range}
                            options={eng6ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {eng6rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {eng6rangeError}
                            </p>
                          )}
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            I enjoy working here.
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Eng7"
                            onChange={handleChangeeng7range}
                            options={eng7ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {eng7rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {eng7rangeError}
                            </p>
                          )}
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            The work I do is meaningful to me.
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Eng8"
                            onChange={handleChangeeng8range}
                            options={eng8ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {eng8rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {eng8rangeError}
                            </p>
                          )}
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            I feel that there is a conscious effort in our
                            startup to facilitate internal career opportunities.
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Do1"
                            onChange={handleChangedo1range}
                            options={do1ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {do1rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {do1rangeError}
                            </p>
                          )}
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            In our startup, one is committed to facilitating
                            lifelongcareer prospects.
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Do2"
                            onChange={handleChangedo2range}
                            options={do2ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {do2rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {do2rangeError}
                            </p>
                          )}
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            To remain in our startup represents excellent future
                            career opportunities.
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Do3"
                            onChange={handleChangedo3range}
                            options={do3ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {do3rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {do3rangeError}
                            </p>
                          )}
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            Our startup invests considerable resources in the
                            development of its employees (e.g., through
                            training, courses, and career development).
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Dp1"
                            onChange={handleChangedp1range}
                            options={dp1ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {dp1rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {dp1rangeError}
                            </p>
                          )}
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            Our startup appears to be very concerned about the
                            continuous development of its employees’ skills and
                            abilities.
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Dp2"
                            onChange={handleChangedp2range}
                            options={dp2ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {dp2rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {dp2rangeError}
                            </p>
                          )}
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            Through actual allocation of time and money to
                            employee development our startup shows that it truly
                            invests in its employees.
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Dp3"
                            onChange={handleChangedp3range}
                            options={dp3ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {dp3rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {dp3rangeError}
                            </p>
                          )}
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            The match is very good between the demands of my job
                            and my personal skills.
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Daf1"
                            onChange={handleChangedaf1range}
                            options={daf1ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {daf1rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {daf1rangeError}
                            </p>
                          )}
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            My abilities and training are a good fit with the
                            requirements of my job.
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Daf2"
                            onChange={handleChangedaf2range}
                            options={daf2ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {daf2rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {daf2rangeError}
                            </p>
                          )}
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            My personal abilities and education provide a good
                            match with the demands that my job places on me.
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Daf3"
                            onChange={handleChangedaf3range}
                            options={daf3ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {daf3rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {daf3rangeError}
                            </p>
                          )}
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            Our talent pool is sufficient to handle the current
                            workload.
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Bed1"
                            onChange={handleChangeBed1range}
                            options={bed1ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {bed1rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {bed1rangeError}
                            </p>
                          )}
                          <label
                            className="ml-2 align-middle inline-block"
                          >
                            Our startup is able to attract suitable talent for
                            upcoming tasks in the future.
                            <span className="required">*</span>
                          </label>
                          <CustomSelect
                            id="select-Bed2"
                            onChange={handleChangeBed2range}
                            options={bed2ranges}
                            placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                          />
                          {bed2rangeError !== "" && (
                            <p className="ml-2 -mt-3 text-red-400 ">
                              {bed2rangeError}
                            </p>
                          )}
                          <div className="flex mt-4 mb-6 ml-2 text-left items-left">
                            <input
                              required
                              id="privacy"
                              type="checkbox"
                            ></input>
                            <label
                              htmlFor="privacy"
                              className="ml-2 align-middle inline-block"
                            >
                              I agree to the{" "}
                              <a href="https://station-frankfurt.de/datenschutzerklaerung/">
                                privacy policy.
                              </a>
                              <span className="required">*</span>
                            </label>
                          </div>
                          <button
                            id="submit"
                            type="submit"
                            className="w-full mb-4 tertiary link-bold"
                            disabled={loadingTalentScore}
                          >
                            Submit form
                          </button>
                  </div>
              </form>
            </div>
          </div>
        </>
      )}
      {success && done && valid && (
        <div className="items-center mx-auto mt-8 text-center">
          <h2>We have received the registration of your Talent Score.</h2>
          <Link to="/" className="items-center w-full">
            <li className="float-none w-56 mx-auto mt-8 list-none topbar-link-primary">
              Back to the map
            </li>
          </Link>
        </div>
      )}
      {done && !valid && (
        <div className="items-center mx-auto mt-8 text-center">
          <h2>There was an error with your token.</h2>
          <p className="mt-4 text-copy-main-regular">
            Please verify that your link is valid and not expired.
          </p>
          <Link to="/" className="items-center w-full">
            <li className="float-none w-56 mx-auto mt-8 list-none topbar-link-primary">
              Back to map
            </li>
          </Link>
        </div>
      )}
    </div>
  );
}

export default TalentScore;